import { useEffect, useRef } from 'react';
import { useAppStore } from '@/store';

export function useEngine(): void {
  const rawInput = useAppStore((s) => s.rawInput);
  const runDetection = useAppStore((s) => s.runDetection);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      runDetection();
    }, 100);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [rawInput, runDetection]);
}
